import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Grid,
  Typography,
  Button,
  Card,
  TextField,
  Breadcrumbs,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { apiData } from "../services/api-methods";
import API, { FrontendURL } from "../APIUrls";
import Header from "./header";
import { Alert, AlertTitle } from "@mui/material";
import Footer from "./footer";

const validationSchema = yup.object({
  // name: yup.string().required("Name is required"),
  address: yup.string().required("Address is required"),
  // email: yup
  //   .string()
  //   .email("Enter a valid email")
  //   .required("Email is required"),
  // contactNo: yup
  //   .string()
  //   .matches(
  //     /^[0-9]{10}$/,
  //     "Phone number must be 10 digits long and contain only numbers"
  //   )
  //   .required("Contact number is required"),
  postalCode: yup.string().required("Postal Code is required"),
  suburb: yup.string().required("Suburb is required"),
  coupon: yup.string().required("Coupon is required"),
});

const PropertyAdd = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const formik = useFormik({
    initialValues: {
      id: "",
      name: "",
      email: "",
      contactNo: "",
      address: "",
      postalCode: "",
      suburb: "",
      coupon: "",
      status: 1,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setLoading(true);
        let tempData = await apiData("post", API.property, values);

        if (tempData.statusCode >= 200 && tempData.statusCode < 400) {
          setMessage({ status: "success", msg: tempData.msg });
        }
        setTimeout(() => {
          window.location.href = FrontendURL + "/property";
        }, 1000);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    },
  });
  async function fetchData(id) {
    let temp = { id: id };

    let data = await apiData("get", API.property, temp);

    if (data.data) {
      formik.setValues({
        id: data.data._id,
        name: data.data.name,
        email: data.data.email,
        contactNo: data.data.contactNo,
        postalCode: data.data.postalCode,
        address: data.data.address,
        suburb: data.data.suburb,
        coupon: data.data.coupon,
        status: data.data.status,
      });
    }
  }

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);

  return (
    <>
      <Header />
      {message && message.status && (
        <Alert severity={`${message.status}`}>
          <AlertTitle>{message.status}</AlertTitle>
          {message.msg && <>{message.msg}</>}
        </Alert>
      )}

      <Grid className="employee-form">
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3}>
            <Grid
              textAlign="center"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <Typography className="page_title" textAlign="left">
                Add Property
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="property/list">
                  List
                </Link>
                <Typography color="text.primary">Add </Typography>
              </Breadcrumbs>
            </Grid>

            <Grid
              item
              xs={12}
              lg={6}
              md={6}
              textAlign="right"
              sx={{ alignSelf: "flex-end", mt: 2 }} // Adding margin top to the button
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<ArrowBackIosIcon />}
                onClick={() => navigate("/property")}
              >
                Back
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Card sx={{ p: 2, mt: 2 }}>
                <Grid container spacing={2}>
                  {/* <Grid item xs={12} md={6}>
                    <TextField
                      name="name"
                      label="Name"
                      fullWidth
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      error={formik.touched.name && Boolean(formik.errors.name)}
                      helperText={formik.touched.name && formik.errors.name}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      name="email"
                      label="Email"
                      fullWidth
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      name="contactNo"
                      label="Contact Number"
                      fullWidth
                      value={formik.values.contactNo}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.contactNo &&
                        Boolean(formik.errors.contactNo)
                      }
                      helperText={
                        formik.touched.contactNo && formik.errors.contactNo
                      }
                    />
                  </Grid> */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      name="address"
                      label="Address"
                      fullWidth
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.address && Boolean(formik.errors.address)
                      }
                      helperText={
                        formik.touched.address && formik.errors.address
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      name="postalCode"
                      label="Postal Code"
                      fullWidth
                      value={formik.values.postalCode}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.postalCode &&
                        Boolean(formik.errors.postalCode)
                      }
                      helperText={
                        formik.touched.postalCode && formik.errors.postalCode
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="suburb"
                      type="suburb"
                      label="Suburb"
                      fullWidth
                      value={formik.values.suburb}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.suburb && Boolean(formik.errors.suburb)
                      }
                      helperText={formik.touched.suburb && formik.errors.suburb}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="coupon"
                      type="text"
                      label="Coupon Code"
                      fullWidth
                      value={formik.values.coupon}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.coupon && Boolean(formik.errors.coupon)
                      }
                      helperText={formik.touched.coupon && formik.errors.coupon}
                    />
                  </Grid>
                  {/* {formik.values.id !== "" && (
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={formik.values.status}
                          name="status"
                          fullWidth
                          onChange={(e) =>
                            formik.setFieldValue("status", e.target.value)
                          }
                          error={
                            formik.touched.status &&
                            Boolean(formik.errors.status)
                          }
                          helperText={
                            formik.touched.status && formik.errors.status
                          }
                        >
                          <MenuItem value={1}>Active</MenuItem>
                          <MenuItem value={2}>In Active</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  )} */}
                  <Grid item xs={12} className="buttonContainer">
                    <Button
                      variant="contained"
                      style={{ background: "#426e5a" }}
                      type="submit"
                      disabled={loading}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </form>
      </Grid>
      <Footer />
    </>
  );
};

export default PropertyAdd;
